import React from 'react'
import { Status } from '../../components/cards/statusTag'
import { TableComponent } from '../../components/table'
import { HeaderSubheader } from '../../components/typography/HeaderSubheader'
import { useGetPermissionsQuery } from '../../redux-toolkits/user/user.slice'

const PremissionsSection: React.FC = () => {
  const { data: permissions, isLoading } = useGetPermissionsQuery(
    {
      skip: 0,
      limit: 1000,
    },
    { refetchOnMountOrArgChange: true },
  )

  return (
    <div>
      <div className="flex flex-col gap-10">
        <div className="flex items-center">
          <HeaderSubheader
            title="Permissions"
            text="View available permissions for your team members."
          />
        </div>

        <div className="w-full overflow-x-scroll">
          <TableComponent
            loading={isLoading}
            headers={['Section', 'Description', 'Status', 'Code']}
            rows={
              permissions?.data?.map((permission) => {
                return {
                  id: permission._id,
                  content: [
                    permission?.section ?? '',
                    permission.description,
                    <Status
                      key={`${permission._id}-status`}
                      text={!permission.active ? 'Inactive' : 'Active'}
                      type={!permission.active ? 'fail' : 'success'}
                    />,
                    permission.code,
                  ],
                }
              }) ?? []
            }
          />
        </div>
      </div>
    </div>
  )
}

export default PremissionsSection
